import styled from 'styled-components';
import '@bnnvara/typography';
const IconButton = styled.button`
  background: transparent;
  cursor: pointer;
  border: none;
  appearance: none;
  outline: none;
  display: inherit;
  padding: 0;
  margin: 0;
  color: none;

  &:focus {
    outline: ${({
  theme
}) => `2px solid ${theme.base.blue}`};
    outline-offset: 2px;
  }
`;
export default IconButton;